import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { FormGroup } from "@angular/forms";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { IonicModule, MenuController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
@Component({
  selector: "app-standard-promotion",
  templateUrl: "./standard-promotion.component.html",
  styleUrls: ["./standard-promotion.component.scss"],
  animations: [bounceIn],
  standalone: true,
  imports: [IonicModule],
})
export class StandardPromotionComponent implements OnInit {
  isNumberInvalid: boolean;
  countryCode: any;
  msn: any;
  cell1TelInput = {
    initialCountry: CommonVariable.countryCode,
    separateDialCode: false,
  };
  update = false;
  updateForm: FormGroup;
  currentPasswordIcon = "eye-off";
  currentPasswordType = "password";
  newPasswordIcon = "eye-off";
  newPasswordType = "password";

  @ViewChild("mobileNumber") mobileNumber: ElementRef;
  phoneInValid: boolean = false;
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: any;
  sub: any;
  proceed = true;
  apiFailed: boolean;
  isOnline: boolean = true;
  messageData: any;
  backgroundImage: string;
  sanitizedMessage: SafeHtml;
  public userId: string;
  constructor(
    private firestore: Firestore,
    private bottomSheet: MatBottomSheetRef<StandardPromotionComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private authService: AuthService,
    public translate: TranslateService,
    private menu: MenuController,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {
    this.messageData = data?.message;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    this.backgroundImage =
      this.messageData?.template_data?.background_url != "" ? this.messageData?.template_data?.background_url : "";
  }

  async ngOnInit() {
    await this.authService.getUid("StandardPromotionComponent").then((uid) => {
      this.userId = uid;
    })
    Network.addListener("networkStatusChange", (e) => {
      try {
        if (e.connected) {
          this.isOnline = true;
        } else {
          this.isOnline = false;
        }
      } catch (error) {
        return error;
      }
    });

    if (this.messageData && this.messageData?.template_data && this.messageData?.template_data?.message) {
      const rawHtml = this.messageData?.template_data?.message;
      this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
      this.updateInbox()
    }
  }

  onCTA() {
    this.bottomSheet.dismiss();
    const destination = this.messageData?.destination;
    if (!destination) return;
    this.menu.close("inboxMenu");
    // Extract fragment (after '#') and path (with possible query)
    const [fullPath, fragment] = destination?.split('#');
    const url = new URL(window?.location?.origin + fullPath);
    const path = url?.pathname;
    const queryParams = Object.fromEntries(url?.searchParams?.entries());
    // Navigate using Angular router
    this.router.navigate([path], { queryParams, fragment });
  }

  backToDetails(isLiked) {
    this.bottomSheet.dismiss(isLiked);
  }

  close() {
    this.bottomSheet.dismiss();
  }


  updateInbox() {
    const limbId = this.messageData?.limb_id === this.messageData?.id ? this.messageData?.limb_id : this.messageData?.id;
    const inboxUpdate = this.messageData?.view_count + 1;
    const inboxViewed = inboxUpdate >= this.messageData?.view_capping;
    const updatePayload = {
      auto_show: false,
      viewed: true,
      view_count: inboxUpdate,
    };
    if (inboxViewed || this.messageData?.dismissed === true || this.messageData?.view_count >= this.messageData?.view_capping) {
      updatePayload["hide"] = true;
    }
    if (limbId && this.userId && updatePayload) {
      const path_id = "dQ2JLcXGOr5fbVp8gyIf";
      const doc_data = updatePayload;
      const dv = { docId: limbId };
      const method = "update";

      this.authService.getV2CloudFunction("updatefirestoredoc", {
        path_id,
        doc_data,
        dv,
        method,
      }).subscribe({
        error: (error) => {
          console.error("Error updating Firestore document:", error);
          return error;
        }
      });
    }
  }
}
